const rawApiUrl = process.env.REACT_APP_API_URL?.trim() || "/api";
const rawAppType = process.env.REACT_APP_APP_TYPE?.trim() || "customer";

if (rawAppType !== "customer") {
  throw new Error("REACT_APP_APP_TYPE must be customer");
}

export const env = {
  apiUrl: rawApiUrl.replace(/\/$/, ""),
  appType: rawAppType,
  apiTimeoutMs: 65_000,
} as const;
